module.exports = __webpack_public_path__ + "img/CAPT_Panaguiton.39cbbd4b.jpg";